require.register("modules/m03/m03-activity/page-14/page-14", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page14 = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page14;

  
});

